// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2X6eY","title":"Header_title__2YzRw","side":"Header_side__3tM6d"};